import { ID } from '../../types/typeDef';
import { UsersPermissionsUser } from '../../graphql/generated/graphql';
import { errEleveInfos } from './testEleve/testInfos';
import { UserOnHome } from '../../types/user/user.def';

export const USER_ROLE = localStorage.getItem('role');
export const MY_ID: ID = localStorage.getItem('id');

export type ROLE = 'eleve' | 'professeur' | 'admin' | 'public' | null;

export const AUTH_TOKEN = `Bearer ${localStorage.getItem('token')}`;
export const ELEVE_ROLE = 'eleve';
export const PROF_ROLE = 'professeur';
export const PROF_ID = process.env.REACT_APP_PROF_ID;

export const ELEVE_ID = process.env.REACT_APP_ELEVE_ID;
export const ADMIN_ROLE = 'admin';

export const IS_ADMIN = USER_ROLE === ADMIN_ROLE;
export const IS_ELEVE = USER_ROLE === ELEVE_ROLE;
export const IS_PROF = USER_ROLE === PROF_ROLE;

export const isLogged: boolean =
  localStorage.getItem('token') && localStorage.getItem('id') && true;
export const isAllowedToAccesDashboard = (classe: boolean): boolean => {
  return classe && (IS_PROF || IS_ELEVE || IS_ADMIN) && true;
};
export const needToCompleteProfile = (user: UserOnHome): boolean =>
  IS_ELEVE && errEleveInfos(user);
export const needToCreateClasse = (classe: boolean): boolean =>
  !classe && IS_PROF && true;

interface StoreAuthData {
  jwt: string;
  userId: ID;
  username: UsersPermissionsUser['username'];
  roleType: ROLE;
}

export const storeAuthData = ({
  jwt,
  userId,
  username
}: Omit<StoreAuthData, 'roleType'>) => {
  localStorage.setItem('token', jwt);
  localStorage.setItem('id', userId);
  localStorage.setItem('username', username);
};

export const storeRoleType = (roleType: StoreAuthData['roleType']) => {
  console.log('roleType', roleType);
  localStorage.setItem('role', roleType);
};
